export const REFEREE_REVIEW_PANEL_TYPE_ID = '33462a72-a260-483b-98f9-06380d9c72cc';

export const JUDGING_REVIEW_PANEL_TYPE_ID = 'e90f431a-161b-4e09-a8fb-b8b398a6de74';